class LocalStorageServices {
  static getToken = () => localStorage.getItem('token') || '';

  static setToken = (token) => {
    localStorage.setItem('token', token);
  };

  static removeToken = () => {
    localStorage.removeItem('token');
  };

  static getProfile = () => {
    const profile = localStorage.getItem('profile');
    if (typeof profile !== 'string') {
      return {};
    }
    return JSON.parse(profile);
  };

  static setProfile = (data) => {
    localStorage.setItem('profile', JSON.stringify(data));
  };

  static removeProfile = () => {
    localStorage.removeItem('profile');
  };

  static getSystemCountry = () => {
    const country = localStorage.getItem('systemCountry');
    if (typeof country !== 'string') {
      return {};
    }
    return JSON.parse(country);
  };

  static setSystemCountry = (data) => {
    localStorage.setItem('systemCountry', JSON.stringify(data));
  };

  static removeSystemCountry = () => {
    localStorage.removeItem('systemCountry');
  };

  static getIsWorkingWithOnlineCategories = () => {
    const val = localStorage.getItem('isWorkingWithOnlineCategories');
    return val === 'true';
  };

  static setIsWorkingWithOnlineCategories = (data) => {
    localStorage.setItem('isWorkingWithOnlineCategories', data);
  };

  static removeIsWorkingWithOnlineCategories = () => {
    localStorage.removeItem('isWorkingWithOnlineCategories');
  };

  static getPaymentOnlineCity = () => {
    try {
      const raw = localStorage.getItem('nomad_payment_online_city');
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed._id === 'string' ? parsed : null;
    } catch {
      return null;
    }
  };

  static setPaymentOnlineCity = (city) => {
    if (city && typeof city._id === 'string') {
      localStorage.setItem('nomad_payment_online_city', JSON.stringify({ _id: city._id, name: city.name || 'Онлайн' }));
    }
  };
}

export default LocalStorageServices;
